import React from "react";

interface ToggleSwitchProps {
    label: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ label, checked, onChange, disabled = false }) => {
    return (
        <div className={`toggle-switch ${disabled ? "disabled" : ""}`} style={{ display: "flex", alignItems: "center", width: 'max-content' }}>
            <label style={{ marginRight: "5px" }}>{label}</label>
            <label className="input-switch">
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={(e) => onChange(e.target.checked)}
                    disabled={disabled}
                />
                <span className="input-slider"></span>
            </label>
        </div>
    );
};

export default ToggleSwitch;

const styles = `
:root {
    --primary-color: #007bff;
    --primary-color-hover: #0056b3;
    --secondary-color: #D6E8FF;
}

.toggle-switch {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.toggle-switch label {
    font-size: 18px; /* Increase font size for the label */
    color: #555;
    margin-right: 15px; /* Gap between label and slider */
    white-space: nowrap; /* Ensure label text doesn't break into a new line */
}

.input-switch {
    position: relative;
    display: inline-block;
    width: 50px; /* Reverted to original width of the slider */
    height: 28px; /* Reverted to original height of the slider */
}

.input-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.input-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
    border-radius: 28px; /* Adjust border-radius for original size */
}

.input-slider:before {
    position: absolute;
    content: "";
    height: 24px; /* Original circle size */
    width: 24px; /* Original circle size */
    left: 2px;
    bottom: 2px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
}

.input-switch input:checked + .input-slider {
    background-color: var(--primary-color);
}

.input-switch input:checked + .input-slider:before {
    transform: translateX(22px); /* Adjust the translation for original size */
}

.toggle-switch.disabled {
    opacity: 0.6;
    pointer-events: none;
}

.toggle-switch.disabled label {
    color: #999;
}

.toggle-switch input:focus + .input-slider {
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.3);
}
`;

// Inject styles into the page
const styleTag = document.createElement('style');
styleTag.innerHTML = styles;
document.head.appendChild(styleTag);